// Image source types
export const ImageSourceType = {
  NOMAROI: "nomaroi",
  LOCAL: "local",
  EXTERNAL: "external",
};

/**
 * Generates a full image URL based on the source and options
 * @param {string} src - The image source path or URL
 * @param {Object} options - Options for URL generation
 * @param {string} [options.type=ImageSourceType.EXTERNAL] - The image source type (NOMAROI, LOCAL, EXTERNAL)
 * @param {string} [options.path=''] - The path segment for LOCAL type images
 * @returns {string} The full image URL
 */
export const getImageUrl = (src, { type = ImageSourceType.EXTERNAL, path = "" } = {}) => {
  if (!src) return "";

  switch (type) {
    case ImageSourceType.NOMAROI:
      return `https://api2.nomaroi.com/${src}`;
    case ImageSourceType.LOCAL:
      return `${process.env.REACT_APP_IMAGE_URL || ""}/images/${path}/${src}`.replace(/\/+$/, "");
    case ImageSourceType.EXTERNAL:
    default:
      return src;
  }
};
